export default __webpack_public_path__ + "static/media/bneyzion100.1d6e8e62.png";